.graphic-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.graphic {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 80%;
}

.graphic > svg {
    width: 150px;
    margin-top: 41px;
}

.contact {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.icon-background {
    composes: background from '../graphics-pieces/icon-background.module.css';
}

.entity {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 128px;
}

.entity-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    bottom: 0;
}

.accounts-icon {
    position: absolute;
    width: 80px;
}

.subtitle {
    color: var(--grey-dk);
    font-style: italic;
}
